import React, { useState } from 'react';
import { useLaunchParams } from '@telegram-apps/sdk-react';
import { ExchangeConnectList } from '@/components/ExchangeConnectList';
import { ReferralBottomNav } from '@/components/ReferralBottomNav';
import { AutotradeTriggerManager } from '@/components/AutotradeTriggerManager';
import { NeedHelpCard } from '@/components/NeedHelpCard';
import { PageHeader } from '@/components/ui/PageHeader';
import { TabSelector } from '@/components/TabSelector';

type SettingsTab = 'exchanges' | 'autotrade';

export const SettingsPageMobile: React.FC = () => {
  const launchParams = useLaunchParams();
  const userId = launchParams.initData?.user?.id?.toString() || '';
  const [tab, setTab] = useState<SettingsTab>('exchanges');
  const [guideRequest, setGuideRequest] = useState(0);

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 overflow-y-auto p-4 pb-28">
        <div className="max-w-2xl mx-auto flex flex-col gap-4">
          <PageHeader
            title="Settings"
            subtitle="Manage your exchange connections and autotrade settings"
          />
          <TabSelector
            options={[
              { value: 'exchanges', label: 'Exchanges' },
              { value: 'autotrade', label: 'Autotrade' },
            ]}
            value={tab}
            onChange={setTab}
          />
          {/* Kept mounted so the connect guide opened from "View Guide" survives the tab switch. */}
          <div className={tab === 'exchanges' ? '' : 'hidden'}>
            <ExchangeConnectList userId={userId} guideRequest={guideRequest} />
          </div>
          {tab === 'autotrade' && (
            <>
              <AutotradeTriggerManager userId={userId} />
              <NeedHelpCard onViewGuide={() => setGuideRequest((n) => n + 1)} />
            </>
          )}
        </div>
      </div>
      <ReferralBottomNav />
    </div>
  );
};
